export default ({
  state: {
    filter_bajas: [
      { field: 'selectDataServer', name: 'Departamento', nameid: 'departamento_id', action: 'ShowFieldDinamic', isHidden: ['bien', 'inventario'], url: '/inventarios/bajas/getdepartamento', rules: true, cols: 4 },
      { field: 'selectDataServer', type: 'text', name: 'Tipo de bien', nameid: 'bien', action: 'ShowFieldDinamic', isHidden: ['inventario'], url: '/catalogo/familias/tips?estatus_id=42', default: '/catalogo/familias/tips?estatus_id=42', hidden: true, rules: true, cols: 4 },
      { field: 'selectDataServer', type: 'text', name: 'Tipo de inventario', nameid: 'inventario', url: '/empresa/tipo-actividades/tipos?estatus_id=42', params: '', paramslist: ['departamento_id', 'bien'], hidden: true, rules: true, cols: 4 }
    ],
    filter_transferencia: [
      { field: 'selectDataServer', type: 'text', name: 'Tipo de bien', nameid: 'bien', action: 'ShowFieldDinamic', isHidden: ['inventario'], url: '/catalogo/familias/tips?estatus_id=43', default: '/catalogo/familias/tips?estatus_id=43', rules: true, cols: 6 },
      { field: 'selectDataServer', type: 'text', name: 'Tipo de inventario', nameid: 'inventario', url: '/empresa/tipo-actividades/tipos?estatus_id=43', params: '', paramslist: ['departamento_id', 'bien'], hidden: true, rules: true, cols: 6 }
    ],
    filter_seguimientos: [
      { field: 'selectDataServer', name: 'Usuario', nameid: 'usuario_id', url: '/empresa/usuarios', cols: 6, rules: true, itemValue: 'id' },
      { field: 'selectDataServer', name: 'Estatus', nameid: 'estatus', url: '/procesos/estatus/est', cols: 6, rules: true, itemValue: 'id' }
    ]
  },
  getters: {
    get_filter_bajas (state) { return state.filter_bajas },
    get_filter_transferencia (state) { return state.filter_transferencia },
    get_filter_seguimientos (state) { return state.filter_seguimientos }
  },
  mutations: {},
  actions: {}
})
